<template>
		<div class="content">
      <Header></Header>
      <div class="nav">
      	<span class="">{{$t('referral')}}</span>
      </div>
      <div class="personal-info" style="text-align: center;font-size: 24px">
        <div class="mission-content">
<!--          <div class="mission-h ">-->
<!--            <div class="mt50" v-html="$t('referralTips1')"></div>-->
<!--          </div>-->
          <img class="mt20" src="../../static/images/referral-img.png" />
          <div class="referral-list">
            <div class="mission-ul">
              <div class="mt20">
                {{$t('Invitation_Link')}}
              </div>
              <div class="referral-c ">
                <div class="ac">
  <!--                <div class="fw7 fs20">{{$t('referralTips2')}}</div>-->
                  <div class="fen dib app-en" style="width:90%">

                    <input class="input"  v-model="info.invite_url" style="font-size: 28px;width: 100%;" readonly>
                    <!-- <span style="font-size: 20px">{{$t('Invitation_Count')}}:{{info.invite_count}}</span>
                   <img id="copycode" :data-clipboard-text="info.invite_url" @click="copy(info.invite_url)" src="../../static/images/copy.png"> -->
                  </div>
                </div>
                <div class="ac">
  <!--                <div class="fw7 fs20">{{$t('referralTips3')}}</div>-->
                  <div class="mt20" style="">
  <!--                  <input class="input fen" v-model="invited_code" style="width:80%;" />-->
                    <div class="btn btn1" id="copycode" style="margin:0 auto" :data-clipboard-text="info.invite_url" @click="copy(info.invite_url)">
                      {{$t('Copy')}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog ref="answerDialog" type="alert" :callback="answerModal" title="" width="100" :modalFoot="false">
          <div class="" slot="mdBox" >
            <div class="answer-modal" v-if="answerReson.is_correct==1">
              <div style="width:90%;margin:0 auto">
                <div class="">
                  <div class="title dui">{{$t('Correct')}}:)</div>
                  <img width="100" src="../../static/images/dui.png" />
                  <div class="answer-t1">
                    {{$t('ansTitle1')}}
                  </div>
                  <div class="answer-t2">
                    {{$t('ansTitle2')}}{{answerReson.num}}{{$t('ansTitle22')}}
                  </div>
                  <button class="btn btn-blue1 mt20" @click="answerModal">{{$t('OK')}}</button>
                </div>
              </div>
            </div>
            <div class="answer-modal answer-modal-cuo" v-if="answerReson.is_correct==0">
              <div style="width:90%;margin:0 auto">
                <div class="">
                  <div class="title cuo">{{$t('wrong')}} :(</div>
                  <img width="100" src="../../static/images/cuo.png" />
                  <div class="answer-t1">
                    {{$t('ansTitle3')}}
                  </div>
                  <div class="answer-t2">
                    {{$t('ansTitle2')}}{{answerReson.num}}{{$t('ansTitle22')}}
                  </div>
                  <button class="btn btn-blue1 mt20" @click="answerModal">{{$t('OK')}}</button>
                </div>
              </div>
            </div>
          </div>
      </Dialog>
      <Dialog ref="alertDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
          <div class="alert-modal" slot="mdBox" >
              <div class="login-c ac">
                <div class="ac" style="font-size:38px;margin:20px auto 15px;color:#c20b0b;text-transform: uppercase;padding-top:40px;" v-html="$t('congratulations')"></div>
                <div class="ac" style="color:#001d80;margin:0 auto 40px;font-size:34px;" v-html="invitedAlert"></div>
              </div>
          </div>
      </Dialog>
		</div>
</template>
<script>
import Header from '../components/header'
import Clipboard from 'clipboard';
import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog
    },
    data() {

    return {
			info:{},
      invited_code:'',
      invitedAlert:'',
      answerReson:{}
		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();
	},
    methods: {
		back(){
			this.$router.push({path:'/'})
		},
    answerModal(){

    },
		getHome(){
			let that =this;
      that.$parent.loadModal(true);
			that.$api.get('/api/user/info',null,r =>{
				that.$parent.returnCode(r,function(){
          that.$parent.loadModal(false);
        that.info = r.data
      });

			})
		},
    invitedCode(){
      let that = this;
      let data = {
        invited_code:that.invited_code
      }
      that.$api.post('/api/invitation/code',data,r =>{
        if(r.msg) that.$utils.alertText(r.msg);
      	that.$parent.returnCode(r,function(){
          that.invitedAlert = r.data.msg
          that.$refs.alertDialog.showMaskFun();
        });

      })
    },
    copy(item){
        var clipboard = new Clipboard("#copycode");
        clipboard.on("success", (e) => {
          this.$utils.alertText(this.$t('CopySucceeded'));
          // 释放内存
          clipboard.destroy();
        });
        clipboard.on("error", (e) => {
          // 不支持复制
          //console.log("该浏览器不支持自动复制");
          // 释放内存
          clipboard.destroy();
        });
    }
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/referral.vue